import {
  useInView as useIntersectionObserver,
  IntersectionOptions,
} from 'react-intersection-observer'

/**
 * React implementation of the Intersection Observer API to tell you when an element enters or leaves the viewport.
 * @see https://www.npmjs.com/package/react-intersection-observer
 * @example
 * ```
 * const { inView, ref } = useInView({ delay: 1000 })
 * ```
 */
export const useInView = (props: IntersectionOptions) => {
  return useIntersectionObserver(props)
}
